import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/insurers/serviceCenters/store/serviceCenterSlice/initialState.ts'
import { ServiceCenter } from '@/modules/insurers/serviceCenters/types/ServiceCenter.ts'

const serviceCenterSlice = createSlice({
  name: 'serviceCenter',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setServiceCenters: (state, action: PayloadAction<ServiceCenter[]>) => {
      state.serviceCenters = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const serviceCenterActions = serviceCenterSlice.actions
export const { reducer: serviceCenterReducer } = serviceCenterSlice
